import React from 'react';

interface PrintSurveyQuestionFormProps {
  optionCount?: number;
}

export function PrintSurveyQuestionForm({ optionCount = 4 }: PrintSurveyQuestionFormProps) {
  const options = Math.min(Math.max(optionCount, 3), 6);

  return (
    <div className="print-survey-question-form">
      <div className="print-survey-question-form__section">
        <p className="print-survey-question-form__label">Tu pregunta</p>
        <div className="print-survey-question-form__lines" aria-hidden>
          <span className="print-survey-question-form__line" />
          <span className="print-survey-question-form__line" />
        </div>
      </div>
      <div className="print-survey-question-form__section">
        <p className="print-survey-question-form__label">Opciones de respuesta</p>
        <ol className="print-survey-question-form__options">
          {Array.from({ length: options }, (_, index) => (
            <li key={index} className="print-survey-question-form__option">
              <span className="print-survey-question-form__option-num">{index + 1}.</span>
              <span className="print-survey-question-form__option-line" aria-hidden />
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
